import { camelCase } from '../util.js'
const works = [
  {
    title: '大闹天宫六小龄童',
    desc: '大闹天宫六小龄童',
    thumb: camelCase('cases-brand-hla-0'),
    zpic: [
      camelCase('cases-brand-hla-0')
    ]
  },
  {
    title: 'HLA_Bremen_F01_0264',
    desc: 'HLA_Bremen_F01_0264',
    thumb: camelCase('cases-brand-hla-1'),
    zpic: [
      camelCase('cases-brand-hla-1')
    ]
  },
  {
    title: 'HLA_Bremen_F06_1716 X',
    desc: 'HLA_Bremen_F06_1716 X',
    thumb: camelCase('cases-brand-hla-2'),
    zpic: [
      camelCase('cases-brand-hla-2')
    ]
  },
  {
    title: '大闹天宫六小龄童1_yy_6he',
    desc: '大闹天宫六小龄童1_yy_6he',
    thumb: camelCase('cases-brand-hla-3'),
    zpic: [
      camelCase('cases-brand-hla-3')
    ]
  },
  {
    title: 'HLA_Bremen_F02_0638',
    desc: 'HLA_Bremen_F02_0638',
    thumb: camelCase('cases-brand-hla-4'),
    zpic: [
      camelCase('cases-brand-hla-4')
    ]
  },
  {
    title: 'HLA_Bremen_F06_1909 RGB X',
    desc: 'HLA_Bremen_F06_1909 RGB X',
    thumb: camelCase('cases-brand-hla-5'),
    zpic: [
      camelCase('cases-brand-hla-5')
    ]
  },
  {
    title: '图层 5',
    desc: '图层 5',
    thumb: camelCase('cases-brand-hla-6'),
    zpic: [
      camelCase('cases-brand-hla-6')
    ]
  },
  {
    title: '大闹天宫四人版_zy_1',
    desc: '大闹天宫四人版_zy_1',
    thumb: camelCase('cases-brand-hla-7'),
    zpic: [
      camelCase('cases-brand-hla-7')
    ]
  },
  {
    title: 'HLA_Bremen_F02_0594',
    desc: 'HLA_Bremen_F02_0594',
    thumb: camelCase('cases-brand-hla-8'),
    zpic: [
      camelCase('cases-brand-hla-8')
    ]
  },
  {
    title: '图层 6',
    desc: '图层 6',
    thumb: camelCase('cases-brand-hla-9'),
    zpic: [
      camelCase('cases-brand-hla-9')
    ]
  },
  {
    title: '播放',
    desc: '播放',
    thumb: camelCase('cases-brand-hla-10'),
    zpic: [
    ]
  },
  {
    title: '播放 副本',
    desc: '播放 副本',
    thumb: camelCase('cases-brand-hla-11'),
    zpic: [
    ]
  },
  {
    title: '播放 副本 2',
    desc: '播放 副本 2',
    thumb: camelCase('cases-brand-hla-12'),
    zpic: [
    ]
  },
  {
    title: '送金币活动图',
    desc: '送金币活动图',
    thumb: camelCase('cases-brand-hla-13'),
    zpic: [
      camelCase('cases-brand-hla-13')
    ]
  },
  {
    title: '003 HWFAJ3E031A31 598元',
    desc: '003 HWFAJ3E031A31 598元',
    thumb: camelCase('cases-brand-hla-14'),
    zpic: [
      camelCase('cases-brand-hla-14')
    ]
  },
  {
    title: '横版主K',
    desc: '横版主K',
    thumb: camelCase('cases-brand-hla-15'),
    zpic: [
      camelCase('cases-brand-hla-15')
    ]
  }
]
export default {
  name: '海澜之家',
  logo: {
    default: camelCase('cases-brand-2'),
    active: camelCase('cases-brand-2-cover')
  },
  works
}
